import React from 'react';
import styles from './CustomerBenefitsMP.module.css';
import { Row, Col, Container } from 'reactstrap';
import { ReactComponent as CheckmarkIcon } from '../../assets/images/Vendor/MainlinePlus/benefits-checkmark.svg';

const CustomerBenefitsMP = () => {
    const serviceBenefits = () => {
        const serviceInfo = [
            'Labor Repair Costs',
            'Trip and Diagnostic Costs',
            'Service Provided by You, the Preferred Servicer',
            'Transferable at No Cost',
            'No Deductible or Service Fee'
        ];
        return serviceInfo?.map((benefit, index) => {
            return (
                <div key={index}>
                    <div>
                        <CheckmarkIcon />
                    </div>
                    <div>{benefit}</div>
                </div>
            );
        });
    };

    return (
        <>
            <Container
                fluid
                className={styles.customerBenefitsContainer}
            >
                <Container>
                    <Row>
                        <Col
                            sm='12'
                            md='12'
                            lg='6'
                            className='p-0'
                        >
                            <div className={styles.vendorImage}></div>
                        </Col>
                        <Col
                            sm='12'
                            md='12'
                            lg='6'
                            className='p-0'
                        >
                            <div className={styles.benefitsContainer}>
                                <h1>Offer More to Your Customers</h1>
                                <p>
                                    Extended service agreements help protect your customers' budgets while providing
                                    peace of mind that their equipment will be professionally maintained. As the
                                    preferred servicer, you can deliver a positive experience that builds trust and
                                    generates referrals.
                                </p>
                                <div className={styles.serviceBenefits}>{serviceBenefits()}</div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
            <Container
                fluid
                className={styles.contentContainer}
            >
                <h1>Let's grow your business together.</h1>
            </Container>
            <Container
                fluid
                className={styles.footerContainer}
            >
                <Container>
                    <p className='mb-0'>
                        *Limitations and exclusions apply. See terms and conditions for further information. Service
                        contract is provided by Service Net Warranty, LLC, part of AIG, or one or more of its
                        affiliates.
                    </p>
                </Container>
            </Container>
        </>
    );
};

export default CustomerBenefitsMP;
